import React from 'react';

// TODO: move this to EDS
const SearchIconSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="66"
        height="66"
        viewBox="0 0 66 66"
    >
        <g fill="none" fillRule="evenodd" transform="translate(1)">
            <circle
                cx="35.5"
                cy="29.5"
                r="29.5"
                fill="#EFF2F5"
            />
            <g transform="translate(0 14)">
                <path
                    stroke="#363A43"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M30.9998,19.9883 L20.9998,29.9883"
                />
                <polygon fill="#F6682F" points="0 48.988 0 46.988 19 27.988 23 31.988 4 50.988 2 50.988" />
                <polygon
                    stroke="#363A43"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    points="0 48.988 0 46.988 19 27.988 23 31.988 4 50.988 2 50.988"
                />
                <path fill="#FFF" d="M50.2498,14.9883 C50.2498,23.0653 43.7018,29.6133 35.6248,29.6133 C27.5478,29.6133 20.9998,23.0653 20.9998,14.9883 C20.9998,6.9113 27.5478,0.3633 35.6248,0.3633 C43.7018,0.3633 50.2498,6.9113 50.2498,14.9883" />
                <path stroke="#363A43" strokeWidth="2" d="M50.2498,14.9883 C50.2498,23.0653 43.7018,29.6133 35.6248,29.6133 C27.5478,29.6133 20.9998,23.0653 20.9998,14.9883 C20.9998,6.9113 27.5478,0.3633 35.6248,0.3633 C43.7018,0.3633 50.2498,6.9113 50.2498,14.9883 Z" />
                <path
                    stroke="#363A43"
                    strokeLinecap="round"
                    strokeWidth="1.59"
                    d="M34.7884,5.8252 C30.2794,5.8252 26.6244,9.4802 26.6244,13.9882"
                />
            </g>
        </g>
    </svg>
);

export default SearchIconSvg;
